import { createSelector } from 'reselect'

import * as constants from './constants'

export const bannedIPs = state => state.getIn(['bannedIPs', 'ips'], [])

export const fetchBannedIPsSuccess = createSelector(
  state => state.getIn(['bannedIPStatus', 'status', 'fetch']),
  fetchBannedIPsStatus => fetchBannedIPsStatus === constants.FETCH_BANNED_IPS_SUCCESS
)

export const fetchBannedIPsPending = createSelector(
  state => state.getIn(['bannedIPStatus', 'status', 'fetch']),
  fetchBannedIPsStatus => fetchBannedIPsStatus === constants.FETCH_BANNED_IPS_PENDING
)

export const fetchBannedIPsFailed = createSelector(
  state => state.getIn(['bannedIPStatus', 'status', 'fetch']),
  fetchBannedIPsStatus => fetchBannedIPsStatus === constants.FETCH_BANNED_IPS_FAILED
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/ban/selectors.js